import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	connect() {
		this.element.querySelectorAll('svg').forEach((svg) => {
			const paths = svg.querySelectorAll('path');

			paths.forEach((path, index) => {
				const length = path.getTotalLength();
				const delay = index * 0.5 + 1;

				path.style.setProperty('--stroke-length', length);
				path.style.setProperty('--stroke-delay', `${delay}s`);
			});
		});
	}
}
